// import React, { useEffect, useRef, useState } from "react";
// import blinkshare from "../../../assets/patientcharts/blinkscribe 2.svg";
// import recordbutton from "../../../assets/patientcharts/recordbutton.png";
// import redwave from "../../../assets/patientcharts/redwave.png";
// import messageIcon from "../../../assets/patientcharts/mingcute_more-3-fill.svg";
// import TypeofVisitPop from "./TypeofVisitPop";
// import { useNavigate } from "react-router-dom";
// import redcircle from "../../../assets/audio/redcircle.png";
// import pause from "../../../assets/audio/Pause.png";
// import play from "../../../assets/audio/play.png";
// import stop from "../../../assets/audio/ion_stop.png";
// import redmic from "../../../assets/audio/redmic.png";
// import ExitModal from "../overlays/exitmodal";
// import ReactiveWaves from "../../../streaming/reactivewaves";
// import blinkscribeapi from "../../../api/blinkscribeapi";
// import DeleteConfirmation from "../overlays/deleteconformation";
// import useAudioRecorder from "../../../blinkscribe/audiorecorderhook";
// import { Backdrop, CircularProgress } from "@mui/material";
// import NurseAssistant from "../../../../src/assets/Signin/nurseassistant.svg";
// import api from "../../../api/api";
// import TimerOffIcon from "@mui/icons-material/TimerOff";
// import { eventBus } from "../../../utils/eventBus";
// import ToastMessage from "../../../utils/mui/righttoptoast";
// import { useSelector } from "react-redux";
// import { ChatIcon, GoogleIcon, orangetick } from "./svg";
// import ConfirmReviewModal from "./googleModal";
// import { set } from "date-fns";
// import dayjs from "dayjs";
import { useRecording } from "../../../context/RecordingContext";

// const SideFrame = ({
//   audiotabchange,
//   onClose,
//   currentTab,
//   isreocrdingdisabled,
//   fetchpcarddata,
//   data,
//   setChat,
// }) => {
//   const [percentage, setPercentage] = useState(20);
//   const [activeButton, setActiveButton] = useState(3);
//   const [loading, setLoading] = useState(false);
//   const [TypeofVisit, setTypeofVisit] = useState(false);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const practiseid = getPracticeId();
//   const [initialData, setInitialData] = useState([]);
//   const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
//   const [showTooltip, setShowTooltip] = useState(false);
//   const [showTick, setShowTick] = useState(false);

//   const lovValue = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
//   );
//   const tovValue = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
//   );
//   const homescreenprev = useSelector(
//     (state) => state.userPrivileges.homescreen
//   );
//   const navigate = useNavigate();

//   const [exitModal, setExitModal] = useState(false);
//   const [pollTrigger, setPollTrigger] = useState(0);
//   const pollRef = useRef(null);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false);
//   const [isError, setIsError] = useState(false);

//   const lov2Value = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
//   );
//   const tov2Value = useSelector(
//     (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
//   );
//   const orders = useSelector((state) => state.orders.orders);
//   const [alertMode, setAlertMode] = useState(true);
//   const token = localStorage.getItem("auth");
//   const [openToast, setOpenToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");
//   const [toastSeverity, setToastSeverity] = useState("success");
//   const [showPopup, setShowPopup] = useState(false);

//   // === Global Recording Context ===
//   const {
//     isGlobalRecording,
//     isGlobalPaused,
//     globalElapsedTime,
//     audioStreamRef,
//     startRecording: contextStartRecording,
//     stopRecording: contextStopRecording,
//     togglePause: contextTogglePause,
//     onSave: contextOnSave,
//     onDelete: contextOnDelete,
//     submitAudioBlobManually,
//     setShowFloatingPopup,
//     setIsOnRecordingPage,
//     registerManualRecording,
//     showToastRef,
//     setPollTriggerRef,
//     combineStatusRef,
//     latestAppRef,
//     streamNameRef,
//     stopTimer: contextStopTimer,
//     pausedRef,
//   } = useRecording();

//   // Local aliases for readability (these come from global context now)
//   const isRecording = isGlobalRecording;
//   const isPaused = isGlobalPaused;
//   const elapsedTime = globalElapsedTime;

//   const handleToastClose = () => {
//     setOpenToast(false);
//   };

//   // Provide manual audio blob handler to context
//   const onSaving = (blob) => {
//     submitAudioBlobManually(blob);
//   };

//   const {
//     manualrecord,
//     stopmanualRecording,
//     pausemanualRecording,
//     resumemanualRecording,
//   } = useAudioRecorder(onSaving);

//   // Register manual recording hooks with the global context
//   useEffect(() => {
//     registerManualRecording({
//       manualrecord,
//       stopmanualRecording,
//       pausemanualRecording,
//       resumemanualRecording,
//     });
//   }, [manualrecord, stopmanualRecording, pausemanualRecording, resumemanualRecording]);

//   // Register toast callback with context
//   useEffect(() => {
//     showToastRef.current = (message, severity) => {
//       setToastMessage(message);
//       setToastSeverity(severity);
//       setOpenToast(true);
//     };
//     setPollTriggerRef.current = setPollTrigger;
//   }, []);

//   // Mark that user is on the recording page
//   useEffect(() => {
//     setIsOnRecordingPage(true);
//     setShowFloatingPopup(false);
//     return () => {
//       setIsOnRecordingPage(false);
//       // Show floating popup when user leaves this page while recording is active
//       // We read from isGlobalRecording directly can be stale, so use a small trick
//     };
//   }, []);

//   // Track recording state for cleanup
//   const isRecordingRef = useRef(false);
//   useEffect(() => {
//     isRecordingRef.current = isRecording;
//   }, [isRecording]);

//   // When component unmounts while recording, show popup
//   useEffect(() => {
//     return () => {
//       if (isRecordingRef.current) {
//         setShowFloatingPopup(true);
//       }
//     };
//   }, []);

//   const handleButtonClick = (index) => {
//     setActiveButton(index);
//   };

//   const toggleCollapse = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   const circleStyle = {
//     background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
//       percentage * 3.6
//     }deg)`,
//   };

//   const togglePause = () => {
//     contextTogglePause();
//   };

//   const formatTime = (seconds) => {
//     const minutes = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
//       2,
//       "0"
//     )}`;
//   };

//   const onExit = () => {
//     setExitModal(false);
//     contextOnSave();
//   };

//   const deleteStream = async () => {
//     setExitModal(false);
//     setDeleteConfirmationModal(false);
//     await contextOnDelete();
//   };

//   const angle = percentage * 3.6;
//   const radians = (angle - 90) * (Math.PI / 180);
//   const radius = 35;
//   const smallCircleOffset = 8;

//   const smallCircleStyle = {
//     position: "absolute",
//     top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
//     left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
//     width: "28px",
//     height: "28px",
//     backgroundColor: "#FFFFFF",
//     borderRadius: "50%",
//     transform: "translate(-50%, -50%)",
//     boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
//   };

//   const handleAlarmData = async ({ PateintData }, AlertCondition) => {
//     try {
//       const response = await api.put(
//         `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/update_alarm_alert`,
//         {
//           appointment_id: PateintData.appointmentid,
//           emergency_alert: AlertCondition,
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated Successfully");
//         handleAlertModeData(PateintData);
//       } else {
//         console.error("Failed ");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   const handleAlertModeData = async (PateintData) => {
//     try {
//       const response = await api.post(
//         `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/get_sign_details`,
//         {
//           appointment_id: PateintData.appointmentid,
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated Successfully");
//         setAlertMode(response.data?.emergency_alert);
//       } else {
//         console.error("Failed ");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   useEffect(() => {
//     const payload = {
//       filter_array: {
//         date_filter: {
//           start_date: dayjs().format("YYYY-MM-DD"),
//           end_date: dayjs().format("YYYY-MM-DD"),
//         },
//       },
//     };

//     const checkRecording = async () => {
//       const res = await blinkscribeapi.post(
//         `/v1/patient/${data.patientid}/recording/details`,
//         payload
//       );
//       console.log("checking for summarized");
//       if (res.status !== 200) return;

//       const list = res.data || [];

//       if (!list.length) {
//         setShowTick(false);
//         return;
//       }

//       const latest = list.sort(
//         (a, b) => dayjs(b.ts).valueOf() - dayjs(a.ts).valueOf()
//       )[0];

//       if (latest.transcriptionstatus === "Summarized") {
//         setShowTick(true);
//         clearInterval(pollRef.current);
//       } else {
//         setShowTick(false);
//       }
//     };

//     checkRecording();
//     pollRef.current = setInterval(checkRecording, 3000);

//     return () => clearInterval(pollRef.current);
//   }, [data.patientid, pollTrigger]);

//   const handleProviderShow = async ({ ProviderData }) => {
//     try {
//       const response = await api.put(
//         `/v1/${practiseid}/checkin/patient/${ProviderData.patientid}/update_provider`,
//         {
//           appointment_id: ProviderData.appointmentid,
//           provider_check: "true",
//         }
//       );
//       if (response.status === 200) {
//         console.log("Updated ProviderName Successfully");
//       } else {
//         console.error("Failed to Updated ProviderName Successfully");
//       }
//     } catch (error) {
//       console.error("Error unassigning room:", error);
//     }
//   };

//   const fetchData = async () => {
//     try {
//       const response = await api.get(
//         `/v1/${practiseid}/orders/patient/${data?.patientid}/condition`
//       );
//       if (response.status === 200) {
//         setInitialData(response.pConditions);
//       }
//     } catch (error) {
//       console.error("Error fetching patient conditions:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const FetchRecorderData = async () => {
//     try {
//       setLoading(true);
//       const payload = {
//         filter_array: {
//           date_filter: {
//             start_date: dayjs().format("YYYY-MM-DD"),
//             end_date: dayjs().format("YYYY-MM-DD"),
//           },
//         },
//       };

//       const res = await blinkscribeapi.post(
//         `/v1/patient/${data.patientid}/recording/details`,
//         payload
//       );

//       if (res.status === 200) {
//         return res.data || [];
//       }
//       return [];
//     } catch (err) {
//       console.log("FetchRecorderData error:", err);
//       return [];
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkappointments = async () => {
//     try {
//       setLoading(true);
//       const recordings = await FetchRecorderData();

//       if (!recordings.length) {
//         combineStatusRef.current = false;
//         const result = await startRecording();
//         if (result.success) setLoading(false);
//         return;
//       }

//       const currentAppointments = recordings.filter(
//         (x) => x.appointmentid == data.appointmentid
//       );

//       if (!currentAppointments.length) {
//         combineStatusRef.current = false;
//         const result = await startRecording();
//         if (result.success) setLoading(false);
//         return;
//       }

//       const latest = currentAppointments.reduce((a, b) =>
//         dayjs(b.ts).isAfter(dayjs(a.ts)) ? b : a
//       );

//       const isToday = dayjs(latest.ts).isSame(dayjs(), "day");
//       const hasAudio = !!latest.audiolink;

//       if (isToday && hasAudio) {
//         latestAppRef.current = latest;
//         combineStatusRef.current = true;
//         await contextStartRecording(data, token, true, latest);
//       } else {
//         combineStatusRef.current = false;
//         await startRecording();
//       }
//     } catch (error) {
//       console.log("checkappointments error:", error);
//       setToastMessage("Something went wrong.");
//       setToastSeverity("info");
//       setOpenToast(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlestartrecording = () => {
//     const today = dayjs().startOf("day");
//     const apptDate = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss").startOf(
//       "day"
//     );

//     if (apptDate.isAfter(today)) {
//       setToastMessage("Recording for future dates is not allowed.");
//       setToastSeverity("info");
//       setOpenToast(true);
//       return;
//     }

//     checkappointments();
//   };

//   const trigeerReview = async () => {
//     setLoading(true);
//     try {
//       const response = await api.post(
//         `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
//       );
//       if (response.status === 200) {
//         setToastSeverity("success");
//         setToastMessage(response?.message || "Notification Sent Successfully");
//         setOpenToast(true);
//       } else {
//         setToastSeverity("info");
//         setToastMessage(response?.message || "something went wrong");
//         setOpenToast(true);
//       }
//     } catch (error) {
//       console.log(error);
//       setToastSeverity("error");
//       setToastMessage(error?.message || "something went wrong");
//       setOpenToast(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <div
//         className={`relative flex  lg:flex-col items-center lg:gap-4 gap-8 p-4 h-full bg-[#fafaf9] shadow-[0px_14px_42px_rgba(8,15,52,0.06)] transition-all duration-300 ease-in-out ${
//           isCollapsed ? "w-16 lg:w-16" : "w-full lg:w-auto h-[100vh]"
//         }`}
//       >
//         {/* Orange Slider Button */}
//         <button
//           onClick={toggleCollapse}
//           className="absolute bottom-2 left-12 lg:bottom-auto lg:top-4 lg:left-auto lg:-right-3 w-6 h-6 bg-[#E17954] rounded-full flex items-center justify-center shadow-lg transition-colors duration-500 z-2"
//         >
//           <svg
//             className={`w-4 h-4 text-white transition-transform duration-300 ${
//               isCollapsed ? "rotate-180" : "rotate-0"
//             }`}
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>

//         {!isCollapsed && (
//           <div className="w-[20%] lg:w-auto items-center flex flex-col">
//             <div
//               className="absolute top-6 cursor-pointer group left-6"
//               onClick={() => setShowPopup(true)}
//             >
//               {GoogleIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap z-50
//     "
//               >
//                 Google Review
//               </div>
//             </div>
//             <div
//               onClick={() => {
//                 setChat(true);
//               }}
//               className="absolute top-6 lg:top-16 left-16 lg:left-6 group cursor-pointer"
//             >
//               {ChatIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap
//     "
//               >
//                 Chat
//               </div>
//             </div>

//             <div
//               className="relative flex justify-center items-center w-[90px] h-[90px] mt-1 mb-0"
//               onMouseMove={(e) => {
//                 const rect = e.currentTarget.getBoundingClientRect();
//                 setTooltipPos({
//                   x: e.clientX - rect.left,
//                   y: e.clientY - rect.top + 15,
//                 });
//               }}
//               onMouseEnter={() => setShowTooltip(true)}
//               onMouseLeave={() => setShowTooltip(false)}
//             >
//               <div
//                 onClick={() => {
//                   if (homescreenprev.includes("P-Card")) {
//                     fetchpcarddata(data.id);
//                     onClose();
//                   }
//                 }}
//                 className="relative cursor-pointer flex justify-center items-center"
//               >
//                 <img
//                   src={`https://cloud.brainymed.com/chim/public/assets/images/profilepictures/${data.patientid}.png`}
//                   alt="profile"
//                   onError={(e) =>
//                     (e.target.src =
//                       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
//                   }
//                   className="flex justify-center items-center w-[65px] h-[65px] border-2 rounded-[14px]"
//                   style={{ border: `3.5px solid #${data.deductiblemet}` }}
//                 />
//                 {showTick && (
//                   <div
//                     className="absolute -top-2 -right-2 w-6 h-6 rounded-full
//                     flex justify-center items-center bg-[#E17954]"
//                   >
//                     {orangetick}
//                   </div>
//                 )}
//               </div>

//               {showTooltip && (
//                 <div
//                   className="absolute bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md pointer-events-none whitespace-nowrap"
//                   style={{
//                     left: tooltipPos.x,
//                     top: tooltipPos.y,
//                     transform: "translate(-50%, 0)",
//                   }}
//                 >
//                   Pcard
//                 </div>
//               )}
//             </div>

//             <div className="flex flex-col items-center mb-0">
//               <div className="font-bold text-[#202020] text-sm text-center">
//                 {data?.firstname + " " + data.lastname || "-"}
//               </div>
//               <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
//                 #{data?.patientid || "-"}
//               </div>
//               <div className="font-medium text-[#7e7e7e] text-[13px] text-center ">
//                 {data?.dob || "-"}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Collapsed State - Show only essential elements */}
//         {isCollapsed && (
//           <div className="flex flex-col items-center mt-6 h-full w-full gap-4">
//             <div
//               className="cursor-pointer group"
//               onClick={() => setShowPopup(true)}
//             >
//               {GoogleIcon}
//               <div
//                 className="
//                  pointer-events-none
//       absolute top-1/2 -translate-y-1/2
//       left-8 lg:-left-3 lg:top-10
//      bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md
//       opacity-0 group-hover:opacity-100 transition-opacity duration-200
//       whitespace-nowrap z-50
//     "
//               >
//                 Google Review
//               </div>
//             </div>
//             <div className="relative group cursor-pointer">
//               {ChatIcon}
//               <div className=" pointer-events-none absolute left-1/2 -translate-x-1/2 -top-8 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
//                 Chat
//               </div>
//             </div>

//             {/* Profile Picture - Smaller version */}
//             <div className="relative flex justify-center items-center w-[50px] h-[50px]">
//               <div
//                 onClick={() => {
//                   if (homescreenprev.includes("P-Card")) {
//                     fetchpcarddata(data.id);
//                     onClose();
//                   }
//                 }}
//                 className="relative flex justify-center cursor-pointer items-center"
//               >
//                 <img
//                   src={`https://cloud.brainymed.com/chim/public/assets/images/profilepictures/${data.patientid}.png`}
//                   alt="profile"
//                   onError={(e) =>
//                     (e.target.src =
//                       "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
//                   }
//                   className="flex justify-center items-center w-[45px] h-[45px]  border-2 border-[pink] rounded-[14px]  "
//                   style={{ border: `2px solid #${data.deductiblemet}` }}
//                 />
//               </div>
//             </div>

//             {!isRecording ? (
//               <div className="flex">
//                 <div
//                   className={`w-10 h-10 cursor-pointer ${
//                     isreocrdingdisabled
//                       ? "opacity-50 pointer-events-none"
//                       : ""
//                   }`}
//                   onClick={() => {
//                     if (!isreocrdingdisabled) {
//                       handleProviderShow({ ProviderData: data });
//                       handlestartrecording();
//                     }
//                   }}
//                 >
//                   <img src={redmic} className="w-[35px] h-[35px]" alt="Mic" />
//                 </div>
//               </div>
//             ) : (
//               <div className="flex flex-col items-center gap-2">
//                 <div className="relative cursor-pointer" onClick={contextTogglePause}>
//                   <img
//                     src={redcircle}
//                     alt="Red Circle"
//                     className="w-[30px] h-[30px]"
//                   />
//                   <img
//                     src={!isPaused ? pause : play}
//                     alt="Pause/Play"
//                     className="absolute inset-0 m-auto w-[15px] h-[15px]"
//                   />
//                 </div>
//                 <div
//                   className="text-black font-normal text-xs"
//                   style={{ fontFamily: "Inter" }}
//                 >
//                   {formatTime(elapsedTime)}
//                 </div>
//                 <div
//                   className="relative cursor-pointer"
//                   onClick={() => {
//                     if (!isPaused) {
//                       contextStopTimer();
//                       pausedRef.current = false;
//                       contextTogglePause();
//                     }
//                     setExitModal(true);
//                   }}
//                 >
//                   <img
//                     src={redcircle}
//                     alt="Red Circle"
//                     className="w-[30px] h-[30px]"
//                   />
//                   <img
//                     src={stop}
//                     alt="Stop"
//                     className="absolute inset-0 m-auto w-[15px] h-[15px]"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* User Icon */}
//             <div
//               className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
//               onClick={toggleCollapse}
//             >
//               <svg
//                 width="19"
//                 height="18"
//                 viewBox="0 0 19 18"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M9.5 16.5C13.6421 16.5 17 13.1421 17 9C17 4.85786 13.6421 1.5 9.5 1.5C5.35786 1.5 2 4.85786 2 9C2 13.1421 5.35786 16.5 9.5 16.5Z"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M9.5 9.75C10.7426 9.75 11.75 8.74264 11.75 7.5C11.75 6.25736 10.7426 5.25 9.5 5.25C8.25736 5.25 7.25 6.25736 7.25 7.5C7.25 8.74264 8.25736 9.75 9.5 9.75Z"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M5.75 15.4965V14.25C5.75 13.8522 5.90804 13.4706 6.18934 13.1893C6.47064 12.908 6.85218 12.75 7.25 12.75H11.75C12.1478 12.75 12.5294 12.908 12.8107 13.1893C13.092 13.4706 13.25 13.8522 13.25 14.25V15.4965"
//                   stroke="#202224"
//                   strokeWidth="1.5"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </div>

//             {/* Calendar Icon */}
//             <div
//               className="flex justify-center items-center w-8 h-8 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200"
//               onClick={toggleCollapse}
//             >
//               <svg
//                 width="21"
//                 height="20"
//                 viewBox="0 0 21 20"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M7.1665 1.66669V5.00002"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M13.8335 1.66669V5.00002"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M16.3333 3.33331H4.66667C3.74619 3.33331 3 4.07951 3 4.99998V16.6666C3 17.5871 3.74619 18.3333 4.66667 18.3333H16.3333C17.2538 18.3333 18 17.5871 18 16.6666V4.99998C18 4.07951 17.2538 3.33331 16.3333 3.33331Z"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//                 <path
//                   d="M3 8.33331H18"
//                   stroke="#1E2A4A"
//                   strokeWidth="1.66667"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </div>

//             {/* Number Button */}
//             <div className="flex justify-center items-center">
//               <button
//                 className={`w-8 h-8 rounded-lg shadow-[0px_0px_4px_2px_#0000001a] flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity duration-200 ${
//                   lovValue === 3
//                     ? "bg-[#e17954] text-white"
//                     : "bg-white text-[#1d2951]"
//                 }`}
//                 onClick={toggleCollapse}
//               >
//                 <div className="font-bold text-xs">{lovValue}</div>
//               </button>
//             </div>

//             {/* DX Text */}
//             <div
//               className="flex justify-center items-center cursor-pointer hover:bg-gray-100 rounded-lg transition-colors duration-200 px-2 py-1"
//               onClick={toggleCollapse}
//             >
//               <div className="text-[#1E2A4A] font-medium text-xs font-font1 ">
//                 DX
//               </div>
//             </div>
//           </div>
//         )}

//         {!isCollapsed && (
//           <div className="flex-grow flex lg:flex-col lg:gap-0 gap-10 items-center  lg:border-t-2 max-h-[65%] thin-visible-scrollbar">
//             <div>
//               <div className="w-full flex justify-center items-center p-0 mt-2 mb-2">
//                 <img
//                   src={blinkshare}
//                   alt=""
//                   className="max-w-full max-h-[150px] object-contain"
//                 />
//               </div>
//               <div className="w-full flex justify-center items-center">
//                 {!isRecording ? (
//                   <div className="flex">
//                     <div className="w-12 h-12 cursor-pointer">
//                       <div
//                         className={` ${
//                           isreocrdingdisabled
//                             ? "opacity-50 pointer-events-none"
//                             : " cursor-pointer"
//                         }`}
//                         onClick={() => {
//                           if (!isreocrdingdisabled) {
//                             handleProviderShow({ ProviderData: data });
//                             handlestartrecording();
//                           }
//                         }}
//                       >
//                         <img
//                           src={redmic}
//                           className="w-[40px] h-[40px] md:w-[50px] md:h-[50px]"
//                           alt="Mic"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="flex gap-4 items-center">
//                     <div
//                       className="relative cursor-pointer"
//                       onClick={contextTogglePause}
//                     >
//                       <img
//                         src={redcircle}
//                         alt="Red Circle"
//                         className="w-[35px] h-[35px]"
//                       />
//                       <img
//                         src={!isPaused ? pause : play}
//                         alt="Pause/Play"
//                         className="absolute inset-0 m-auto w-[20px] h-[20px]"
//                       />
//                     </div>

//                     <div className="flex flex-col items-center h-[90%] justify-between">
//                       <div className="h-4 overflow-hidden">
//                         <ReactiveWaves
//                           isPaused={!isPaused}
//                           mediaStream={audioStreamRef.current}
//                         />
//                       </div>
//                       <div
//                         className="h-3 text-black font-normal"
//                         style={{ fontFamily: "Inter" }}
//                       >
//                         {formatTime(elapsedTime)}
//                       </div>
//                     </div>

//                     <div
//                       className="relative cursor-pointer"
//                       onClick={() => {
//                         if (!isPaused) {
//                           contextStopTimer();
//                           pausedRef.current = false;
//                           contextTogglePause();
//                         }
//                         setExitModal(true);
//                       }}
//                     >
//                       <img
//                         src={redcircle}
//                         alt="Red Circle"
//                         className="w-[35px] h-[35px]"
//                       />
//                       <img
//                         src={stop}
//                         alt="Stop"
//                         className="absolute inset-0 m-auto w-[20px] h-[20px]"
//                       />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             {/* content */}
//             <div className="flex lg:flex-col lg:gap-0 gap-10">
//               <div>
//                 <div className="flex flex-col items-start w-full mt-1">
//                   <div className="font-medium  text-[#7e7e7e] text-[13px]">
//                     Healthcare
//                   </div>
//                   <div className="font-medium break text-left text-[#202020] text-sm mt-1 text-[17.5px]">
//                     {data?.insurancename || "-"}
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[12px]">
//                     Provider
//                   </div>
//                   <div className="font-medium text-[#202020] text-sm mt-1">
//                     {data?.linked_provider || "-"}
//                   </div>
//                 </div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[12px]">
//                     Type of Visit
//                   </div>
//                   <div className="font-medium text-[#202020] text-sm mt-1 flex justify-between w-full">
//                     <div>{tovValue || "-"}</div>
//                   </div>
//                 </div>
//               </div>
//               <div>
//                 <div className="flex flex-col items-start w-full mt-2">
//                   <div className="font-medium text-[#7e7e7e] text-[13px]">
//                     Level Of Visit
//                   </div>
//                   <div className="flex items-center gap-1 px-1 py-1">
//                     {[1, 2, 3, 4, 5].map((number) => (
//                       <button
//                         key={number}
//                         className={`w-9 h-[32px] flex items-center justify-center rounded-lg border-[1px] border-gray-200 shadow-[0px_0px_4px_2px_#0000001a] ${
//                           lovValue === number
//                             ? "bg-[#e17954] text-white"
//                             : "bg-white text-[#1d2951]"
//                         }`}
//                         style={{ left: `${(number - 1) * 30}px` }}
//                       >
//                         <div className="font-bold text-[10px] text-center">
//                           {number}
//                         </div>
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {tov2Value && (
//               <div className="flex flex-col items-start w-full my-2 px-2">
//                 <div className="font-medium text-[#7e7e7e] text-[12px]">
//                   Type of Visit
//                 </div>
//                 <div className="flex items-center w-fit px-3 py-1 my-1 rounded-full border-[1px] border-[#E17954] bg-[#E179542E]">
//                   <span className="text-xs font-medium font-inter text-[#7E7E7E]">
//                     {tov2Value || "-"}
//                   </span>
//                   <span className="ml-2 flex items-center justify-center w-6 h-6 rounded-full bg-[#E17954] text-white text-xs font-bold shadow-sm">
//                     {lov2Value || "-"}
//                   </span>
//                 </div>
//               </div>
//             )}

//             {orders?.diagnosis &&
//               orders.diagnosis.length > 0 &&
//               !isCollapsed && (
//                 <div className="[font-family:'Tahoma'] flex flex-column items-center py-1 text-[#1d2951] text-xs leading-[normal]">
//                   <div>
//                     <div className="flex justify-between font-inter items-center sm:w-[190px]">
//                       DIAGNOSIS
//                       <div></div>
//                     </div>
//                   </div>
//                   <div className="mt-2 max-h-[90px] overflow-y-auto  bg-gray-40 rounded-[10px] border-[1.5px] border-gray-100 mx-2">
//                     <ul className="list-disc pl-4 cursor-pointer ">
//                       {orders.diagnosis.map((condition) => (
//                         <li
//                           key={condition.id}
//                           className="font-semibold text-left text-[#4B5563] text-xs font-thin mb-2 my-2"
//                         >
//                           <strong>{condition.condition_name}</strong>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               )}
//           </div>
//         )}
//       </div>
//       <Backdrop
//         sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         open={loading}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>
//       <ToastMessage
//         message={toastMessage}
//         severity={toastSeverity}
//         open={openToast}
//         handleClose={handleToastClose}
//       />
//       <ExitModal
//         savemodal={exitModal}
//         setDeleteConfirmationModal={setDeleteConfirmationModal}
//         setModalOpen={setExitModal}
//         onExit={onExit}
//       />
//       <DeleteConfirmation
//         savemodal={deleteconfirmationModal}
//         setModalOpen={setDeleteConfirmationModal}
//         onExit={deleteStream}
//       />
//       <ConfirmReviewModal
//         isOpen={showPopup}
//         onClose={() => setShowPopup(false)}
//         onConfirm={() => {
//           trigeerReview();
//           setShowPopup(false);
//         }}
//       />
//     </>
//   );
// };

// export default SideFrame;


import React, { useEffect, useRef, useState } from "react";
import blinkshare from "../../../assets/patientcharts/blinkscribe 2.svg";
import recordbutton from "../../../assets/patientcharts/recordbutton.png";
import redwave from "../../../assets/patientcharts/redwave.png";
import messageIcon from "../../../assets/patientcharts/mingcute_more-3-fill.svg";
import TypeofVisitPop from "./TypeofVisitPop";
import { useNavigate } from "react-router-dom";
import redcircle from "../../../assets/audio/redcircle.png";
import pause from "../../../assets/audio/Pause.png";
import play from "../../../assets/audio/play.png";
import stop from "../../../assets/audio/ion_stop.png";
import redmic from "../../../assets/audio/redmic.png";
import RecordRTC, { StereoAudioRecorder } from "recordrtc";
import ExitModal from "../overlays/exitmodal";
import ReactiveWaves from "../../../streaming/reactivewaves";
import blinkscribeapi from "../../../api/blinkscribeapi";
import LiveScribePanel from "./LiveScribePanel";
import CareIQVitals from "../tabs/careiq/CareIQVitals";
import DeleteConfirmation from "../overlays/deleteconformation";
import useAudioRecorder from "../../../blinkscribe/audiorecorderhook";
import { Backdrop, CircularProgress, Popover } from "@mui/material";
import { saveAudioInIndexDB } from "../../../offlinestreaming/offlineBlobHandler";
import NurseAssistant from "../../../../src/assets/Signin/nurseassistant.svg";
import api from "../../../api/api";
import careiqapi from "../../../api/careiqapi";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import { generateFilename } from "../../../utils/generatefilename";
import { eventBus } from "../../../utils/eventBus";
import ToastMessage from "../../../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import { ChatIcon, GoogleIcon, orangetick } from "./svg";
import ConfirmReviewModal from "./googleModal";
import AddIcon from "@mui/icons-material/Add";
import { set } from "date-fns";
import DiagnosisPopup from "../../../orders/popups/diagnosispopup";
import CallIcon from '@mui/icons-material/Call';
import dayjs from "dayjs";
import CustomDropdown from "../../../sidenavs/orders/CustomDropdown";
import { updatelov2Value, updatelovValue, updateTov2Value, updateTovValue } from "../../../reduxtoolkit/dump";
import { useDispatch } from "react-redux";
import { X } from "@mui/icons-material";
import { crossIcon } from "../../modals/svgs";
import { BS_BASE } from "../../../api/bases";
import { classifyVisit, visitLabel, recordingTargetText } from "../../../utils/visitGuard";
import { bsAccessGated, getPracticeId, patientPhotoUrl, practiceFeatures, sideframeShows } from "../../../config/practice";
import { useBsAccess } from "../../../utils/bsAccess";
import { ChevronDown, ChevronLeft, Mic, PencilLine, Stethoscope } from "lucide-react";
import "./chartframe.css";

const PHOTO_FALLBACK =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==";
const BLINKSCRIBE_BASE_URL = `${BS_BASE}`;  // keep in sync with api/blinkscribeapi.js

// import TypeofVisitPop from 'defaultLanding/overlays/TypeofVisit';
const SideFrame = ({
  audiotabchange,
  onClose,
  currentTab,
  setFetchedData,fetchedData,
  isreocrdingdisabled,
 fetchpcarddata,

  data,setChat,
  collapsed,
  onToggleCollapse,
}) => {
  const [percentage, setPercentage] = useState(20);
  const [activeButton, setActiveButton] = useState(3);
  const [loading, setLoading] = useState(false);
  const [TypeofVisit, setTypeofVisit] = useState(false);
  const [localCollapsed, setLocalCollapsed] = useState(false);
  // The chart's top bar owns the toggle now (patientchartwrap passes
  // collapsed/onToggleCollapse); local state only when rendered standalone.
  const isCollapsed = collapsed ?? localCollapsed;
    const [diagnosispopup, setisDiagnosisPopup] = useState(false);
  const practiseid = getPracticeId();
  const [initialData, setInitialData] = useState([]);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
const [showTooltip, setShowTooltip] = useState(false);
const [showTick, setShowTick] = useState(false);
const pollRef = useRef(null);

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  // Level 1-5 → displayed CPT. New-patient visits bill the 99202-05 family
  // (99201 was deleted in 2021 — a level-1 new patient bills 99202); all
  // other visit types show established codes 99211-15. The stored value
  // stays 1-5 either way — only the rendered code changes.
  // A saved Type of Visit wins; most appointments never get one, so fall
  // back to the scheduling purpose ("New Patient", "NEW PT") with the same
  // \bnew\b rule the summarizer uses for its time thresholds.
  const isNewPatientVisit = tovValue
    ? tovValue === "New Patient"
    : /\bnew\b/i.test(String(data?.purpose || ""));
  const lovCpt = (n) => {
    const lvl = Number(n) || 0;
    return isNewPatientVisit ? 99200 + Math.max(2, lvl) : 99210 + lvl;
  };
  // AI-suggested level from the visit note (LiveScribePanel emits it after
  // fetching the note). 0 = no AI suggestion — legacy notes and charts with
  // no recording. Saved lovValue is the provider's choice; the AI value is
  // only ever a suggestion and never overwrites a provider selection.
  const [aiLov, setAiLov] = useState(0);
  // AI-detected preventive/DOT visit class from the note ({cls, seq}) —
  // shown as a click-to-apply Type of Visit suggestion.
  const [aiVisitClass, setAiVisitClass] = useState(null);
  useEffect(() => {
    const onNoteLov = (n) => setAiLov(Number(n) || 0);
    const onVisitClass = (v) => setAiVisitClass(v && v.cls && v.cls !== "em" ? v : null);
    eventBus.on("noteLovLoaded", onNoteLov);
    eventBus.on("noteVisitClassLoaded", onVisitClass);
    return () => {
      eventBus.off("noteLovLoaded", onNoteLov);
      eventBus.off("noteVisitClassLoaded", onVisitClass);
    };
  }, []);
  useEffect(() => {
    setAiLov(0);
    setAiVisitClass(null);
  }, [data?.patientid]);
 const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen
  );
  useEffect(()=>{
    console.log(tovValue,'tovv')

  },[tovValue])
  const navigate = useNavigate();
  const [isPaused, setIsPaused] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  // Set by LiveScribePanel when it has loaded/rendered a note for this chart.
  const [hasFetchedNote, setHasFetchedNote] = useState(false);
  // Sidebar vitals (care.brainymed parity): collapsible block above the note.
  const [sideVitals, setSideVitals] = useState([]);
  const [vitalsCollapsed, setVitalsCollapsed] = useState(false);
  const [streamfilename, setStreamfilename] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientId, setPatientId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false);
  const user = useRef("");
  const [connectionStatus, setConnectionStatus] = useState("Disconnected");
  const [elapsedTime, setElapsedTime] = useState(0); // Total elapsed time in seconds
  const startTimeRef = useRef(null); // Tracks the timer's start/resume time
  const timerRef = useRef(null); // Reference to the timer interval
  const audioStreamRef = useRef(null);
   const userConfig = useSelector((state) => state.userconfig);
  const [isError, setIsError] = useState(false);
  const streamname = useRef();
  const [isblockrecording,setIsBlockRecording]=useState(false)
  // OSA batch 6 (7825, owner 10-01): a user known to have no BlinkScribe in
  // this practice (utils/bsAccess: 401 / 403) gets no mic, recording-target
  // line or note panel -- they could only fail. Shown while the one-per-
  // session check is unanswered; 9928 never checks ("yes").
  const bsAccess = useBsAccess();
  const micHidden = bsAccessGated() && bsAccess === "no";
  const pausedref = useRef(false);
  // Local ref (was mistakenly a prop the parent never passed → undefined →
  // `pendingActionRef.current=true` in startRecording threw and killed recording).
  const pendingActionRef = useRef(false);
   const [alertmessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [open, setOpen] = useState(false);
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const orders = useSelector((state) => state.orders.orders);
  const attemptsRef = useRef(0);
  const blocker = useRef(false);
  const wsRef = useRef(null);
  const ismanualstop = useRef(false);
  const ismanualrecordstart = useRef(false);
  const [alertMode, setAlertMode] = useState(true);
  const token = localStorage.getItem("auth");
  // LiveScribe: the chart mic drives the global RecordingContext (live
  // transcription + floating recorder + SOAP note) instead of the local
  // streaming recorder. contextStartRecording(data, token, combine, latestApp).
  const {
    startRecording: contextStartRecording,
    togglePause: contextTogglePause,
    onSave: contextOnSave,
    onDelete: contextOnDelete,
    isGlobalRecording,
    isGlobalPaused,
    globalElapsedTime,
    audioStreamRef: ctxAudioStreamRef,
    patientInfo: ctxPatientInfo,
    setShowFloatingPopup,
    setIsOnRecordingPage,
    clearLastNote,
    registerManualRecording,
    showToastRef,
    setPollTriggerRef,
    isProcessing,
    lastSOAPNote,
    recordingVisit,
  } = useRecording();

  // ── care.brainymed architecture ──────────────────────────────────────────
  // The in-chart recorder is driven by the global RecordingContext (LiveScribe),
  // NOT the old local streaming recorder. Mirror the context's recording state
  // into the local UI flags this component's render already reads, so clicking
  // the mic flips the panel to pause/stop/timer right here.
  useEffect(() => { setIsRecording(isGlobalRecording); }, [isGlobalRecording]);
  useEffect(() => { setIsPaused(isGlobalPaused); }, [isGlobalPaused]);
  useEffect(() => { setElapsedTime(globalElapsedTime); }, [globalElapsedTime]);

  // On this chart the in-chart recorder is the indicator, so suppress the
  // floating pill; when the provider navigates AWAY mid-session, show the pill.
  const liveRecRef = useRef(false);
  useEffect(() => { liveRecRef.current = isGlobalRecording; }, [isGlobalRecording]);
  useEffect(() => {
    setIsOnRecordingPage(true);
    setShowFloatingPopup(false);
    return () => {
      setIsOnRecordingPage(false);
      if (liveRecRef.current) setShowFloatingPopup(true);
    };
  }, []);

  // Sidebar vitals for this patient (care.brainymed parity). Refetches when the
  // Intake form saves vitals (refreshSidebarVitals).
  useEffect(() => {
    if (!data?.patientid) return;
    let cancelled = false;
    const fetchVitals = async () => {
      try {
        // v2 gateway — its FHIR fallback normalizes units (grams→lbs etc.)
        // and emits the VitalsMaster key shape; v1's fallback returned raw
        // grams (139,252 lbs / BMI 27193, QA 2026-08-24) and wrong keys.
        const res = await careiqapi.post(
          `/v1/fhir-mirror/${practiseid}/vitals/patient/${data.patientid}/vitalscurrent`
        );
        if (!cancelled) {
          setSideVitals(Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []));
        }
      } catch (e) {
        console.warn("[Sidebar] vitals fetch failed", e?.message);
      }
    };
    fetchVitals();
    const handleRefresh = () => fetchVitals();
    eventBus.on("refreshSidebarVitals", handleRefresh);
    return () => {
      cancelled = true;
      eventBus.off("refreshSidebarVitals", handleRefresh);
    };
  }, [data?.patientid, practiseid]);

  // Collapse vitals when a recording ends, so the fresh note has room.
  const wasRecordingRef = useRef(false);
  useEffect(() => {
    if (wasRecordingRef.current && !isGlobalRecording) setVitalsCollapsed(true);
    wasRecordingRef.current = isGlobalRecording;
  }, [isGlobalRecording]);

  // Also start collapsed whenever the chart loads with a note already present
  // (user request 2026-08-20) — the note is the thing being read; vitals stay
  // one click away.
  useEffect(() => {
    if (hasFetchedNote) setVitalsCollapsed(true);
  }, [hasFetchedNote]);

  // "Start recording" clicks from the chart-level nudge banner arrive via
  // eventBus so that component isn't coupled to sideframe's recorder
  // internals. Mirrors the mic button's own onClick (same guards) — without
  // this listener the nudge's button would emit into the void.
  useEffect(() => {
    const handler = () => {
      if (isGlobalRecording || isreocrdingdisabled || isblockrecording || micHidden) return;
      // The visit gate (and, for a non-today visit, the two-step consent)
      // runs inside contextStartRecording; the provider flag is written only
      // once a recording has actually started.
      contextStartRecording(data, token, false, "").then((res) => {
        // res.visit: the visit it started on (the user's own, after a switch)
        if (res && res.success) handleProviderShow({ ProviderData: res.visit || data });
      });
    };
    eventBus.on("startRecordingFromNudge", handler);
    return () => eventBus.off("startRecordingFromNudge", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGlobalRecording, isreocrdingdisabled, isblockrecording, micHidden, data?.patientid, data?.appointmentid, token]);

  // Switching to a different patient's chart while recording auto-saves the
  // active note (you can't record two patients at once).
  useEffect(() => {
    if (
      isGlobalRecording &&
      ctxPatientInfo?.patientid &&
      data?.patientid &&
      String(ctxPatientInfo.patientid) !== String(data.patientid)
    ) {
      contextOnSave();
    }
    if (!isGlobalRecording && clearLastNote) clearLastNote();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.patientid]);
    const [extraAnchorEl, setExtraAnchorEl] = useState(null);
      const extraOpen = Boolean(extraAnchorEl);
   const handleOpenExtra = (e) => setExtraAnchorEl(e.currentTarget);
  const handleCloseExtra = () => setExtraAnchorEl(null);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
const [pollTrigger, setPollTrigger] = useState(0);
  const dispatch = useDispatch();
  const [toastSeverity, setToastSeverity] = useState("success");
  const [showPopup, setShowPopup] = useState(false);
  const handleToastClose = () => {
    setOpenToast(false);
  };
    const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
   const handleChange = (newValue, skipConfirm) => {
    const numericValue = Number(newValue);
    // No recording/AI suggestion for this visit → make the provider confirm
    // an unassisted pick. (Wellness uses First/Subsequent, not CPT levels,
    // and the note-bar override path has its own AI-reasoning confirm —
    // it passes skipConfirm so the provider isn't asked twice.)
    if (!skipConfirm && !aiLov && !tovValue?.includes("Wellness")) {
      const ok = window.confirm(
        `There's no recording or AI-suggested level for this visit yet.\n\n` +
        `Are you sure you want to set the Level of Visit to ${lovCpt(numericValue)}?`
      );
      if (!ok) return;
    }
    dispatch(updatelovValue(numericValue));
    updatelovtov(numericValue,tovValue)
  };

  const handletovChange = (newValue) => {
    dispatch(updateTovValue(newValue));
    updatelovtov(lovValue,newValue)
  };

  // Apply the AI-detected preventive/DOT visit class: sets the Type of Visit
  // (and First/Subsequent as lov 1/2 for wellness) through the normal save path.
  const applyAiVisitClass = () => {
    if (!aiVisitClass) return;
    const map = {
      wellness_medicare: "Wellness Medicare",
      wellness_commercial: "Wellness Commercial",
      dot_physical: "DOT Physical",
    };
    const tovLabel = map[aiVisitClass.cls];
    if (!tovLabel) return;
    const seqNum = aiVisitClass.cls === "dot_physical" ? 0 : (aiVisitClass.seq === "subsequent" ? 2 : 1);
    dispatch(updateTovValue(tovLabel));
    if (seqNum) dispatch(updatelovValue(seqNum));
    updatelovtov(seqNum, tovLabel);
  };

  const handleChange2 = (newValue) => {
    const numericValue = Number(newValue);
    dispatch(updatelov2Value(numericValue));
    updatelov2();
  };

  const handletov2Change = (newValue) => {
    dispatch(updateTov2Value(newValue));
  };
  const onSaving = (blob) => {
    if (blob && blob.type.startsWith("audio/")) {
      console.log("Valid audio blob:", blob);
      // Call the function to submit the audio blob
      if (blocker.current) {
        return;
      }
      console.log("submitting blob");
      submitAudioBlobManually(blob);
    } else {
      console.error("Invalid blob. Not an audio file.");
    }
  };


  useEffect(() => {
  const payload = {
    filter_array: {
      date_filter: {
        start_date: dayjs().format("YYYY-MM-DD"),
        end_date: dayjs().format("YYYY-MM-DD"),
      },
    },
  };

  const checkRecording = async () => {
    const res = await blinkscribeapi.post(
      `/v1/patient/${data.patientid}/recording/details`,
      payload
    );
console.log('checking for summarized')
    if (res.status !== 200) return;

    const list = res.data || [];

    // 1️⃣ no record today → no tick
    // if (!list.length) {
    //   setShowTick(false);
    //   return;
    // }
    if (!list.length) {
      setShowTick(false);
      clearInterval(pollRef.current);
      return;
    }

    // 2️⃣ find latest record using ts
    const latest = list.sort(
      (a, b) => dayjs(b.ts).valueOf() - dayjs(a.ts).valueOf()
    )[0];

    // 3️⃣ summarized → tick & stop loop
    if (latest.transcriptionstatus === "Summarized") {
      setShowTick(true);
      clearInterval(pollRef.current);
    } else {
      setShowTick(false);
    }
  };

  // 🔹 first call
  checkRecording();

  // 🔹 start loop
  // pollRef.current = setInterval(checkRecording, 3000);
if (++attemptsRef.current > 60) {   // ~3 min cap
  clearInterval(pollRef.current);
  return;
}

  return () => clearInterval(pollRef.current);
}, [data.patientid,pollTrigger]);

  const {
    manualrecord,
    stopmanualRecording,
    pausemanualRecording,
    resumemanualRecording,
  } = useAudioRecorder(onSaving);

  // Hand the manual (offline/IndexedDB) recorder to the context so a LiveScribe
  // session can fall back to it — same offline-audio path as care.brainymed.
  useEffect(() => {
    registerManualRecording({
      manualrecord,
      stopmanualRecording,
      pausemanualRecording,
      resumemanualRecording,
    });
  }, [manualrecord, stopmanualRecording, pausemanualRecording, resumemanualRecording]);

  // Route context-fired toasts (saved / cancelled / already-recording / no-audio)
  // through this chart's toast + poll trigger; null them on unmount so the
  // FloatingRecorder fallback takes over. Matches care.brainymed.
  useEffect(() => {
    showToastRef.current = (message, severity) => {
      setToastMessage(message);
      setToastSeverity(severity);
      setOpenToast(true);
    };
    setPollTriggerRef.current = setPollTrigger;
    return () => {
      showToastRef.current = null;
      setPollTriggerRef.current = null;
    };
  }, []);

  const recorderRef = useRef(null);
  const handleButtonClick = (index) => {
    setActiveButton(index);
  };

  const toggleCollapse = () => {
    if (onToggleCollapse) onToggleCollapse();
    else setLocalCollapsed(!localCollapsed);
  };
  const submitAudioBlobManually = async (blob) => {
     pendingActionRef.current=false
    try {
      console.log("inserting into index db ...");
      console.log("userid", user.current.id);
      saveAudioInIndexDB({
        file: blob,
        practiceid: user.current?.config?.practiceid,
        departmentid: user.current?.config?.departmentid,
        patientid: data?.patientid,
        notes: "testing data",
        tags: "tagsdata",
        patientname: `${data?.firstname} ${data?.lastname}`,
        role: "PRO",
        filename: streamname.current,
        appointmentid: data?.appointmentid,
        userid: user.current?.id,
        templatename: "HnP",
      });
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  const togglePause = () => {
    if (isPaused) {
      // Resume the timer
      pausedref.current = false;
      if (ismanualrecordstart) {
        resumemanualRecording();
      }

      startTimer();
    } else {
      // Pause the timer
      pausedref.current = true;

      if (ismanualrecordstart) {
        pausemanualRecording();
      }
      stopTimer();
    }
    setIsPaused((prev) => !prev);
  };
  const startRecording = async () => {
    pausedref.current = false;
    pendingActionRef.current=true
    try {
      setLoading(true);
      const response = await blinkscribeapi.get("/auth/me");
      user.current = response;
      setLoading(false);
      const filenamee = crypto.randomUUID();
      setStreamfilename(filenamee);
      streamname.current = filenamee;
      const notes = "Sample notes";
      const tags = "Sample tags";
      let patientname = `${data?.firstname} ${data?.lastname}`;
      const practiseid = getPracticeId();
      let departmentid = response?.config?.departmentid;
      setPatientId(data?.patientid);
      const appointmentid = String(data?.appointmentid || "").trim();

      const generatedfilename = generateFilename({
        practiceid: practiseid,
        departmentid: departmentid,
        patientid: data?.patientid,
        currentUser: "PRO",
        fileExtension: "txt",
        appointmentid: appointmentid,
      });

      let queryString = `token=${token}&stream_filename=${filenamee}&generated_file_name=${generatedfilename}&practiceid=${practiseid}&departmentid=${departmentid}&patientid=${
        data?.patientid
      }&appointmentid=${appointmentid}&template_name=${"HnP"}&notes=${encodeURIComponent(
        notes
      )}&tags=${encodeURIComponent(tags)}&patientname=${encodeURIComponent(
        patientname
      )}`;

      // hub.preview is a static vhost with no /v2/bs proxy, so
      // window.location.host pointed the socket at itself and it failed with
      // 1006. Use the BlinkScribe API host, same as RecordingContext does.
      let wsOrigin;
      try {
        const apiUrl = new URL(BLINKSCRIBE_BASE_URL, window.location.origin);
        wsOrigin = `${apiUrl.protocol === "https:" ? "wss" : "ws"}://${apiUrl.host}`;
      } catch (e) {
        wsOrigin = `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}`;
      }
      const ws = new WebSocket(
        `${wsOrigin}/v2/bs/v1/recording/streaming?${queryString}`
      );
      setIsRecording(true);
      wsRef.current = ws;

      ws.onopen = () => {
        setConnectionStatus("Connected");
        console.log("WebSocket connection established.");
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        manualrecord();
      };

      ws.onclose = () => {
        if (!ismanualstop.current) {
          ismanualrecordstart.current = true;
          console.log("manual record initiated");
          manualrecord();
        }
        setConnectionStatus("Disconnected");
        console.log("WebSocket connection closed.");
      };

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;
      const recorder = new RecordRTC(stream, {
        type: "audio",
        recorderType: StereoAudioRecorder,
        mimeType: "audio/webm",
        timeSlice: 5000, // Send data every 5 seconds
        desiredSampRate: 48000,
        numberOfAudioChannels: 1,
        ondataavailable: async (blob) => {
          if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
            try {
              const base64Data = await blobToBase64(blob);
              ws.send(base64Data);
            } catch (error) {
              console.error("Error converting blob to base64:", error);
            }
          }
        },
      });

      recorder.startRecording();
      recorderRef.current = recorder;

      setElapsedTime(0);
      startTimer();
      setIsRecording(true);
      setIsPaused(false);
    }catch (error) {
  console.error("Error starting recording:", error);

  // Check only for refresh token failure
  if (error?.message?.includes("Failed to refresh token")) {
    setToastSeverity("error");
    setToastMessage("Please contact the administrator");
    setOpenToast(true);
  }

  setConnectionStatus("Error");
  setLoading(false);
}

  };

  const deleteStream = async () => {
    pendingActionRef.current = false;
    setExitModal(false);
    setDeleteConfirmationModal(false);
    // Discard through the context (LiveScribe): cancels the session, tears down
    // the recorder and shows the cancelled toast. Matches care.brainymed.
    await contextOnDelete();
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const startTimer = () => {
    startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
    timerRef.current = setInterval(() => {
      const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setElapsedTime(timePassed);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  };
  const stopRecording = () => {
    ismanualstop.current = true;
    ismanualrecordstart.current = false;
    if (recorderRef.current) {
      recorderRef.current.stopRecording(() => {
        recorderRef.current = null;
      });
    }

    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close(1000, "Recording stopped by user");
    }
    stopTimer();
    setElapsedTime(0);
    setExitModal(false);
    setIsRecording(false);
    setIsPaused(false);
    setTimeout(() => {
      eventBus.emit("refreshDashboard");
    }, 6000);
  };
  // Calculate the position of the small circle
  const angle = percentage * 3.6; // In degrees
  const radians = (angle - 90) * (Math.PI / 180); // Convert to radians
  const radius = 35; // Radius of the ring (half the width/height of the ring)
  const smallCircleOffset = 8; // Offset to position the small circle
  // 2025-06-26T08:28:23
  const smallCircleStyle = {
    position: "absolute",
    top: `${60 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${60 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px",
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  };

  const onExit = () => {
    pendingActionRef.current = false;
    setExitModal(false);
    // Finalize + save through the context (LiveScribe): it stops the session,
    // shows the toast, generates the note, kicks the offline upload and
    // refreshes the dashboard. Matches care.brainymed.
    contextOnSave();
  };

  const handleAlarmData = async ({ PateintData }, AlertCondition) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/update_alarm_alert`,
        {
          appointment_id: PateintData.appointmentid,
          emergency_alert: AlertCondition,
        }
      );
      if (response.status === 200) {
        console.log("Updated Successfully");
        handleAlertModeData(PateintData);
      } else {
        console.error("Failed ");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };

  const handleAlertModeData = async (PateintData) => {
    try {
      const response = await api.post(
        `/v1/${practiseid}/checkin/patient/${PateintData.patientid}/get_sign_details`,
        {
          appointment_id: PateintData.appointmentid,
        }
      );
      if (response.status === 200) {
        console.log("Updated Successfully");
        setAlertMode(response.data?.emergency_alert);
      } else {
        console.error("Failed ");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };

  const handleProviderShow = async ({ ProviderData }) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/checkin/patient/${ProviderData.patientid}/update_provider`,
        {
          appointment_id: ProviderData.appointmentid,
          provider_check: "true",
        }
      );
      if (response.status === 200) {
        console.log("Updated ProviderName Successfully");
      } else {
        console.error("Failed to Updated ProviderName Successfully");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };
  //
  const checkblinkscribe=async()=>{
    try {
      await blinkscribeapi.get("/auth/me");
    } catch (error) {
       if (error?.message?.includes("Failed to refresh token")) {
    setIsBlockRecording(true)
  }
    }
  }
  const fetchData = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/orders/patient/${data?.patientid}/condition`
      );

      if (response.status === 200) {
        setInitialData(response.pConditions);
      }
    } catch (error) {
      console.error("Error fetching patient conditions:", error);
    } finally {
    }
  };
 const handlediagnosis = () => {
    setisDiagnosisPopup(true);
  };
  useEffect(() => {
    fetchData();
    checkblinkscribe()
  }, []);
  const trigeerReview = async () => {
    // Call-notes practices (7825) never text a patient (the review link is an SMS).
    if (practiceFeatures().callNotes) return;
    setLoading(true);
    try {
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
      );
      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage(response?.message || "Notification Sent Successfully");
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response?.message || "something went wrong");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastSeverity("error");
      setToastMessage(error?.message || "something went wrong");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };
    const getorders = async (x) => {
      try {
        const selectedsuggestions = await api.post(
          `/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`,
          {
            appointmentid: data.appointmentid,
            // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
            orderdate:data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
  
          }
        );
        if (selectedsuggestions.status === 200) {
          const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
          // if (!x) {
          //   if (lovtovItem) {
          //     dispatch(updatelovValue(lovtovItem.lov));
          //     dispatch(updateTovValue(lovtovItem.tov));
          //     dispatch(updatelov2Value(lovtovItem.lov2));
          //     dispatch(updateTov2Value(lovtovItem.tov2));
          //   } else {
          //     // Optional: set defaults if needed
          //     dispatch(updatelovValue(null));
          //     dispatch(updateTovValue(null));
          //     dispatch(updatelov2Value(null));
          //     dispatch(updateTov2Value(null));
          //   }
          // }
  
          // const suggestionList = selectedsuggestions.data?.look || [];
          // setGetOrdersData(selectedsuggestions?.data);
          // setSelectedSuggestionList(suggestionList);
          // setReferals(selectedsuggestions.data?.referrals || []);
          return selectedsuggestions?.data;
        }
      } catch (error) {
        console.log(error);
      }
    };
  
  // The sidebar's Diagnosis list read redux orders.diagnosis, which only the
  // retired Summary tab ever filled, so it stayed empty and a saved diagnosis
  // looked unsaved. Load the visit's diagnoses here (below getorders: TDZ) and
  // reload after any orders/diagnosis save.
  const [visitDx, setVisitDx] = useState([]);
  const loadVisitDxRef = useRef(null);
  loadVisitDxRef.current = async () => {
    if (!data?.patientid || !data?.appointmentid) { setVisitDx([]); return; }
    const d = await getorders("block");
    if (d) setVisitDx(d.diagnosis || []);
  };
  useEffect(() => {
    setVisitDx([]);
    loadVisitDxRef.current();
    const h = () => loadVisitDxRef.current();
    eventBus.on("fetchSummary", h);
    return () => eventBus.off("fetchSummary", h);
  }, [data?.patientid, data?.appointmentid]);
  const updatedashboard=async(x)=>{
    try {
     const payload = {
                    patientid: data.patientid,
                    orderdate:   data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
                  };
       const ordersresp= await api.post(`/v1/${practiseid}/orders/get`, payload);
                  if(ordersresp.status==200){
                    const apiOrders = ordersresp.data; 
const visitTypeOrder = apiOrders.find(
  (order) => order.ordertype === "VISIT"
);

if (visitTypeOrder?.id&&x) {
  await api.put(
    `/v1/${practiseid}/orders/${data.patientid}/update-visit-order/${visitTypeOrder.id}`,{
      ordername:x
    }
  );
     eventBus.emit("fetchSummary")
}
  }
    } catch (error) {
      console.log(error);
    }
    // Refetch the dashboard instead of patching patient.orders with the raw
    // orders/get rows: only the dashboard endpoint labels the card's VISIT row
    // ("EST - Level 4") and drops unconfirmed 'E' rows, so the in-place patch
    // showed the plain Type of Visit until a manual Sync or reload.
    eventBus.emit("refreshDashboard");
}
  const updatelovtov=async(lov,tov)=>{
    console.log(lovValue,tovValue,'lovtovsss')
      try {
        setLoading(true)
         const getorder = await getorders("block");
        const payload = {
        patientid: data.patientid,
        orderdate:data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),

      };

      const getordersss = await api.post(
        `/v1/${practiseid}/orders/get`,
        payload
      );
      let hasVisitOrder;
      if (getordersss.status === 200) {
        hasVisitOrder = getordersss?.data.some(
          (order) => order.ordertype === "VISIT"
        );
      } else {
        hasVisitOrder = false;
      }
  if (tov && hasVisitOrder) {
        if (
          tov=== getorder?.lovtov[0]?.tov &&
          lov === getorder?.lovtov[0]?.lov
        ) {
        } else {
         const response= await api.put(
            `/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,
            {
              patientname: `${data.firstname || ""} ${
                data.lastname || ""
              }`.trim(),
              orderdate:
             data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),

              lov: lov,
              ordlist: tov,
              task: "VISIT",
              loginuser: userConfig?.username,
              user_role: "ALL",
            }
          );
             if(response.status==200){
            
            
               updatedashboard(tov)
                  
                setToastSeverity("success");
        setToastMessage(response?.message || "Type of Visit Updated Successfully");
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(response?.message || "Something Went Wrong");
        setOpenToast(true);
          }
        }
      } else if(tovValue) {
     
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
          {
            department_id: userConfig?.config?.departmentid,
            patient_name: `${data.firstname || ""} ${
              data.lastname || ""
            }`.trim(),
            tov: tov, // purpose
            lov: lov || data.lov,
            diagnosis: "",
            ordertype: "VISIT", // tabs
            ordername: tov, // buttons
            schedule: 'f', // t/f-schedule
            // provider: data.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
           data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
           if(createResponse.status==200){
            
            
               updatedashboard()
                  
                setToastSeverity("success");
        setToastMessage(createResponse?.message || "Type of Visit Updated Successfully");
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(createResponse?.message || "Something Went Wrong");
        setOpenToast(true);
          }
      } else if (lov) {
        // No Type of Visit on this chart (common on migrated/legacy
        // appointments): both branches above are skipped and the click was
        // silently dropped, so the LOV bar reverted to the AI suggestion on
        // the next fetch. Persist the level on its own via ordlist:"".
        const response = await api.put(
          `/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,
          {
            patientname: `${data.firstname || ""} ${
              data.lastname || ""
            }`.trim(),
            orderdate:
              data?.startdate &&
              data?.startdate.includes(" ") &&
              dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
                ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD"),
            lov: lov,
            ordlist: "",
            task: "VISIT",
            loginuser: userConfig?.username,
            user_role: "ALL",
          }
        );
        if (response.status == 200) {
          updatedashboard("");
          setToastSeverity("success");
          setToastMessage(response?.message || "Level of Visit Updated Successfully");
          setOpenToast(true);
        } else {
          setToastSeverity("info");
          setToastMessage(response?.message || "Level of Visit was not saved");
          setOpenToast(true);
        }
      }
      } catch (error) {
        console.log(error)
           setToastSeverity("error");
        setToastMessage("Something Went Wrong");
        setOpenToast(true);
      }finally{
        setLoading(false)
      }
    }
const updatelov2=async()=>{
  try {
    setLoading(true)
   const response= await api.put(
            `/v1/${practiseid}/orders/update/patient/${data.patientid}/secondtovtask`,
            {
              task: "VISIT",
              orderdate:
        data?.startdate &&
data?.startdate.includes(" ") &&
dayjs(data?.startdate.split(" ")[0], "YYYY-MM-DD", true).isValid()
  ? dayjs(data?.startdate.split(" ")[0]).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
              lov2: lov2Value,
              tov2: tov2Value,
            }
          )
          if(response.status==200){
            
            
               updatedashboard()
                  
                setToastSeverity("success");
        setToastMessage(response?.message || "Type of Visit Updated Successfully");
        handleCloseExtra();
        setOpenToast(true);
          }else{
                setToastSeverity("info");
        setToastMessage(response?.message || "Something Went Wrong");
        setOpenToast(true);
          }
  } catch (error) {
    console.log(error)
      setToastSeverity("error");
        setToastMessage("Something Went Wrong");
        setOpenToast(true);
  }finally{
setLoading(false)
  }
}

    const tovOptions = [
    "New Patient",
    "Follow up",
    "Consultation",
    "Wellness Commercial",
    "Wellness Medicare",
    "DOT Physical",
    "Others",
    "Nurse Visit",
    "Labs",
  ].filter((option) => option !== tovValue);
  // Which visit this chart is on, by the clinic's calendar day. The chart
  // resolver (brainycarehome openChart) opens today's visit whenever the
  // patient has one, so anything else here is labelled, and recording on it
  // needs the two-step consent (RecordingContext.startRecording).
  const chartVisit = classifyVisit(data);
  const chartVisitIsToday = chartVisit.kind === "today";
  const chartVisitShort =
    chartVisit.kind === "past" ? "PAST" : chartVisit.kind === "future" ? "FUTURE" : "NO VISIT";
  // While this patient's recording is live, say where IT is going (the visit
  // it started on); otherwise where a new one would go.
  const recordingLineVisit =
    isGlobalRecording &&
    recordingVisit &&
    String(recordingVisit.patientid ?? "") === String(data?.patientid ?? "")
      ? recordingVisit
      : chartVisit;
  // Mic / live-recording controls, shared by the rail and the blinkScribe
  // card. Same gates as before: admin block → toast, disabled (CCM) → no-op,
  // otherwise contextStartRecording runs the visit gate + consent.
  const startChartRecording = () => {
    if (isblockrecording) {
      setToastSeverity("error");
      setToastMessage("Please contact the administrator");
      setOpenToast(true);
      return;
    }
    if (!isreocrdingdisabled) {
      // Flag the provider only once recording has started.
      contextStartRecording(data, token, false, "").then((res) => {
        // res.visit: the visit it started on (the user's own, after a switch)
        if (res && res.success) handleProviderShow({ ProviderData: res.visit || data });
      });
    }
  };
  const stopChartRecording = () => {
    // Pause the live session, then open the save/discard modal.
    if (!isGlobalPaused) contextTogglePause();
    setExitModal(true);
  };
  const recordingControls = (size) => (
    <div className="bmch-rec-live">
      <button type="button" className="bmch-rec-btn" onClick={contextTogglePause} title={isPaused ? "Resume" : "Pause"}>
        <img src={redcircle} alt="" style={{ width: size, height: size }} />
        <img src={!isPaused ? pause : play} alt={isPaused ? "Resume" : "Pause"} className="bmch-rec-glyph" />
      </button>
      <div className="bmch-rec-time">
        {size > 30 && (
          <div className="bmch-rec-wave">
            <ReactiveWaves isPaused={!isPaused} mediaStream={ctxAudioStreamRef.current} />
          </div>
        )}
        {formatTime(elapsedTime)}
      </div>
      <button type="button" className="bmch-rec-btn" onClick={stopChartRecording} title="Stop">
        <img src={redcircle} alt="" style={{ width: size, height: size }} />
        <img src={stop} alt="Stop" className="bmch-rec-glyph" />
      </button>
    </div>
  );
  const openPcard = () => {
    if (homescreenprev.includes("P-Card")) {
      fetchpcarddata(data.id, data);
      onClose();
    }
  };
  // Orange round arrow, the same collapse control as the app side nav and the
  // Orders side panel.
  const collapseArrow = (
    <button
      type="button"
      className={`bmch-arrow${isCollapsed ? " shut" : ""}`}
      onClick={toggleCollapse}
      title={isCollapsed ? "Expand patient panel" : "Collapse patient panel"}
      aria-label={isCollapsed ? "Expand patient panel" : "Collapse patient panel"}
      aria-expanded={!isCollapsed}
    >
      <ChevronLeft />
    </button>
  );
  const isWellnessTov =
    tovValue?.includes("Wellness Commercial") || tovValue?.includes("Wellness Medicare");
  const shownLov = lovValue || aiLov;
  return (
    <>
      {isCollapsed ? (
        /* ---------- Collapsed rail ---------- */
        <div className="bmch bmch-rail">
          <button type="button" className="bmch-rail-back" onClick={onClose} title="Back" aria-label="Back">
            <ChevronLeft />
          </button>
          {collapseArrow}
          {!chartVisitIsToday && (
            <div className="bmch-rail-visit" title={visitLabel(chartVisit)}>
              {chartVisitShort}
            </div>
          )}
          <img
            src={patientPhotoUrl(data.patientid)}
            alt="profile"
            onClick={openPcard}
            onError={(e) => (e.target.src = PHOTO_FALLBACK)}
            className="bmch-rail-photo"
            style={{ boxShadow: `0 0 0 2px #fff, 0 0 0 4px #${data.deductiblemet}` }}
            title="Pcard"
          />
          {!isRecording ? (micHidden ? null : (
            <button
              type="button"
              className={`bmch-rail-mic${isreocrdingdisabled || isblockrecording ? " off" : ""}`}
              onClick={startChartRecording}
              title="blinkScribe - tap to record"
              aria-label="Record"
            >
              <Mic />
            </button>
          )) : (
            <div className="bmch-rail-rec">{recordingControls(30)}</div>
          )}
          <button type="button" className="bmch-rail-item" onClick={toggleCollapse} title="Today's note">
            <PencilLine />
            Note
          </button>
          {sideframeShows("lov") && (
          <button type="button" className="bmch-rail-item" onClick={toggleCollapse} title="Level of visit">
            <span className="bmch-rail-lov">{shownLov ? lovCpt(shownLov) : "-"}</span>
            Level
          </button>
          )}
          {sideframeShows("diagnosis") && (
          <button type="button" className="bmch-rail-item" onClick={handlediagnosis} title="Diagnosis">
            <Stethoscope />
            DX
          </button>
          )}
          <div className="bmch-rail-foot">
            {sideframeShows("googleReview") && (
            <button type="button" className="bmch-side-icon" onClick={() => setShowPopup(true)} title="Google Review">
              {GoogleIcon}
            </button>
            )}
            {sideframeShows("chat") && (
            <button type="button" className="bmch-side-icon" onClick={() => setChat(true)} title="Chat">
              {ChatIcon}
            </button>
            )}
          </div>
        </div>
      ) : (
        /* ---------- Expanded sidebar ---------- */
        <div className="bmch bmch-side">
          <div className="bmch-side-top">
            <button type="button" className="bmch-side-back" onClick={onClose}>
              <ChevronLeft /> Back
            </button>
            <div className="bmch-side-icons">
              {sideframeShows("googleReview") && (
              <button type="button" className="bmch-side-icon" onClick={() => setShowPopup(true)} title="Google Review">
                {GoogleIcon}
              </button>
              )}
              {sideframeShows("chat") && (
              <button type="button" className="bmch-side-icon" onClick={() => setChat(true)} title="Chat">
                {ChatIcon}
              </button>
              )}
              {collapseArrow}
            </div>
          </div>

          <div className="bmch-side-scroll always-visible-scrollbar">
            <div className="bmch-pt">
              <div className="bmch-pt-photo" onClick={openPcard} title="Pcard">
                <img
                  src={patientPhotoUrl(data.patientid)}
                  alt="profile"
                  onError={(e) => (e.target.src = PHOTO_FALLBACK)}
                  style={{ boxShadow: `0 0 0 2px #fff, 0 0 0 4px #${data.deductiblemet}` }}
                />
                {showTick && <span className="bmch-pt-tick">{orangetick}</span>}
              </div>
              <div className="bmch-pt-info">
                <div className="bmch-pt-name">
                  {data?.firstname} {data?.lastname}
                </div>
                <div className="bmch-pt-meta">
                  #{data?.patientid || "-"}
                  {data?.dob ? <> &middot; DOB {data.dob}</> : null}
                </div>
                {data?.phone && <div className="bmch-pt-meta">{data.phone}</div>}
              </div>
            </div>
            {!chartVisitIsToday && (
              <div
                className="bmch-pt-visit"
                title="This chart is not on a visit today. Recording here needs two confirmations."
                data-testid="chart-visit-label"
              >
                {visitLabel(chartVisit)}
              </div>
            )}

            {/* blinkScribe (hidden for a user without BlinkScribe access) */}
            {!(micHidden && !isRecording) && (
            <div className="bmch-side-card bmch-scribe">
              <img src={blinkshare} alt="blinkScribe" className="bmch-scribe-logo" />
              {!isRecording ? (
                <button
                  type="button"
                  className={`bmch-scribe-tap${isreocrdingdisabled || isblockrecording ? " off" : ""}`}
                  onClick={startChartRecording}
                >
                  <span className="bmch-scribe-mic">
                    <Mic />
                  </span>
                  Tap to record
                </button>
              ) : (
                recordingControls(36)
              )}
              {/* Which visit the note is going to (owner rule 2026-09-29). */}
              <div
                className={`bmch-scribe-target${recordingLineVisit.kind === "today" ? "" : " warn"}`}
                data-testid="recording-target"
              >
                {recordingTargetText(recordingLineVisit)}
              </div>
            </div>
            )}

            {/* Vitals (collapsible; auto-collapses when a note arrives) */}
            {sideVitals.length > 0 && (
              <div className="bmch-side-card bmch-side-vitals">
                <button
                  type="button"
                  className="bmch-side-head"
                  onClick={() => setVitalsCollapsed(!vitalsCollapsed)}
                  aria-expanded={!vitalsCollapsed}
                >
                  <span className="bmch-side-label">Vitals</span>
                  <ChevronDown className={vitalsCollapsed ? "shut" : ""} />
                </button>
                {!vitalsCollapsed && (
                  <CareIQVitals patientId={data?.patientid} currentVitals={sideVitals[0]} />
                )}
              </div>
            )}

            {/* Visit: provider, insurance, type and level of visit */}
            <div className="bmch-side-card">
              <div className="bmch-side-head static">
                <span className="bmch-side-label">Level of visit</span>
                {/* Orange chip = provider-set (persisted); blue = AI suggestion only. */}
                {lovValue ? (
                  <span className="bmch-lov-chip">{lovCpt(lovValue)}</span>
                ) : aiLov ? (
                  <span className="bmch-lov-chip ai" title="AI-suggested - click a number to accept or override">
                    {lovCpt(aiLov)}
                  </span>
                ) : null}
              </div>

              {sideframeShows("lov") && !(isWellnessTov || tovValue?.includes("DOT")) && (
                <div className="bmch-lov-row">
                  {[1, 2, 3, 4, 5].map((value) => {
                    const isSaved = lovValue === value;
                    const isAi = aiLov === value;
                    return (
                      <button
                        type="button"
                        key={value}
                        onClick={() => handleChange(value)}
                        title={isAi ? "AI-suggested level" : isSaved ? "Set by provider" : `Set Level of Visit to ${lovCpt(value)}`}
                        className={`bmch-lov-btn${isSaved ? " on" : isAi ? " ai" : ""}`}
                      >
                        {value}
                        {isAi && <span className="bmch-lov-ai">AI</span>}
                      </button>
                    );
                  })}
                  <button type="button" className="bmch-lov-btn add" onClick={handleOpenExtra} title="Add a visit type">
                    <AddIcon sx={{ fontSize: 18 }} />
                  </button>
                </div>
              )}
              {sideframeShows("lov") && isWellnessTov && (
                <select
                  value={lovValue}
                  onChange={(e) => handleChange(e.target.value)}
                  className="bmch-select"
                >
                  <option value="1">First</option>
                  <option value="2">Subsequent</option>
                </select>
              )}
              {tov2Value && (
                <div className="bmch-tov2">
                  <span>{tov2Value}</span>
                  <b>{lov2Value || "-"}</b>
                  <button
                    type="button"
                    onClick={() => {
                      dispatch(updateTov2Value(null));
                      dispatch(updatelov2Value(null));
                    }}
                    aria-label="Remove"
                  >
                    {crossIcon}
                  </button>
                </div>
              )}

              <div className="bmch-field">
                <label className="bmch-field-k" htmlFor="bmch-tov">Type of visit</label>
                <select
                  id="bmch-tov"
                  value={tovValue}
                  onChange={(e) => handletovChange(e.target.value)}
                  className="bmch-select"
                >
                  <option value="" disabled>
                    Select a Visit
                  </option>
                  <option value="New Patient">New Patient</option>
                  <option value="Follow up">Follow up</option>
                  <option value="Consultation">Consultation</option>
                  <option value="Wellness Commercial">Wellness Commercial</option>
                  <option value="Wellness Medicare">Wellness Medicare</option>
                  <option value="Others">Others</option>
                  <option value="Nurse Visit">Nurse Visit</option>
                  <option value="DOT Physical">DOT Physical</option>
                  <option value="Labs">Labs</option>
                </select>
                {/* AI-detected wellness/DOT visit class - click to apply */}
                {aiVisitClass && (() => {
                  const label = aiVisitClass.cls === "dot_physical" ? "DOT Physical"
                    : (aiVisitClass.cls === "wellness_medicare" ? "Wellness Medicare" : "Wellness Commercial")
                      + (aiVisitClass.seq ? ` (${aiVisitClass.seq === "first" ? "First" : "Subsequent"})` : "");
                  const applied = tovValue && label.startsWith(tovValue);
                  return applied ? null : (
                    <button
                      type="button"
                      onClick={applyAiVisitClass}
                      title="Detected from the visit note - click to apply"
                      className="bmch-ai-chip"
                    >
                      AI suggests: {label}
                    </button>
                  );
                })()}
              </div>

              <div className="bmch-kv">
                <div>
                  <span>Provider</span>
                  <b>{data?.linked_provider || "-"}</b>
                </div>
                <div>
                  <span>Healthcare</span>
                  <b>{data?.insurancename || "-"}</b>
                </div>
              </div>

              {sideframeShows("diagnosis") && (
              <div className="bmch-field">
                <div className="bmch-field-k split">
                  Diagnosis
                  <button type="button" className="bmch-side-icon sm" onClick={handlediagnosis} title="Add diagnosis">
                    <AddIcon sx={{ fontSize: 18 }} />
                  </button>
                </div>
                {visitDx.length > 0 && (
                  <ul className="bmch-dx-list">
                    {visitDx.map((condition) => (
                      <li key={condition.icd10 || condition.id}>{condition.condition_name}</li>
                    ))}
                  </ul>
                )}
              </div>
              )}
            </div>

            {/* Today's note: LiveScribePanel is always mounted (it returns
                null when idle with no note). Without it the chart never shows
                a generated note. */}
            {!micHidden && (
            <div className={`bmch-side-note${hasFetchedNote || isRecording || isProcessing || lastSOAPNote ? " bmch-side-card" : ""}`}>
              <LiveScribePanel
                patientId={data?.patientid}
                appointmentDate={data?.startdate}
                onNoteLoaded={(v) => setHasFetchedNote(v)}
                onLovChange={handleChange}
                isNewPatient={isNewPatientVisit}
              />
            </div>
            )}
          </div>

          {/* Popover for additional visit types */}
          <Popover
            open={extraOpen}
            anchorEl={extraAnchorEl}
            onClose={handleCloseExtra}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "center", horizontal: "left" }}
            PaperProps={{
              sx: {
                p: 2,
                width: 260,
                borderRadius: 2,
                boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
                position: "relative",
                overflow: "visible",
                fontFamily: "Inter, sans-serif",
              },
            }}
          >
            <div className="text-[13px] font-medium text-[#7E7E7E] mb-2">Type Of Visit</div>
            <CustomDropdown
              options={tovOptions
                .filter((o) => o === "Wellness Commercial" || o === "Wellness Medicare")
                ?.map((o) => ({ value: o, label: o }))}
              value={tov2Value}
              onChange={handletov2Change}
              placeholder="Select Type"
            />
            <div className="text-[12px] font-medium text-[#1E2A4A] mb-1 mt-3">Level of Visit</div>
            <CustomDropdown
              options={[
                { value: "1", label: "First" },
                { value: "2", label: "Subsequent" },
              ]}
              value={lov2Value}
              onChange={handleChange2}
            />
          </Popover>
        </div>
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
      <ExitModal
        savemodal={exitModal}
        setDeleteConfirmationModal={setDeleteConfirmationModal}
        setModalOpen={setExitModal}
        onExit={onExit}
      />
      <DeleteConfirmation
        savemodal={deleteconfirmationModal}
        setModalOpen={setDeleteConfirmationModal}
        onExit={deleteStream}
      />
 <DiagnosisPopup
        appid={data}
        flow='chart'
        setAlertMessage={setAlertMessage}
        setSeverity={setSeverity}
        setOpen={setOpen}
        isOpen={diagnosispopup}
        onClose={() => setisDiagnosisPopup(false)}
      />
        <ToastMessage
              message={alertmessage}
              severity={severity}
              open={open}
              handleClose={handlealert}
            />
      <ConfirmReviewModal
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        onConfirm={() => {
          trigeerReview();
          setShowPopup(false);
        }}
      />
    </>
  );
};

export default SideFrame;
